<template>
  <div class="content-v2">
    <div class="history-head">
      <span>DEVELOPMENT</span>
      <h2>{{ $t('common.history') }}</h2>
      <p>记录盛博莱从起步、成长到突破的关键节点。</p>
    </div>
    <div class="history-timeline">
      <div class="history-item" v-for="(item, index) in displayHistoryList" :key="item.id">
        <div class="history-left">
          <div class="history-image">
            <img :src="item.image || defaultHistoryImage" :alt="item.title" />
          </div>
        </div>
        <div class="history-axis">
          <span class="history-year">{{ item.year }}</span>
        </div>
        <div class="history-card">
          <div class="history-index">{{ String(index + 1).padStart(2, '0') }}</div>
          <div class="history-content">
            <h3>{{ item.title }}</h3>
            <p>{{ item.content }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getHistoryList } from '@/api/portal'
import { resolveFileUrl } from '@/utils/request'
import defaultImage from '@/assets/images/banner1.svg'

const fallbackHistory = [
  {
    id: 'fallback-1',
    year: '2020',
    title: '公司成立',
    content: '山东盛博莱电力工程有限公司成立，围绕电力技术服务领域建立专业团队，开启电力工程综合服务布局。',
    image: defaultImage
  },
  {
    id: 'fallback-2',
    year: '2023',
    title: '组织建设持续完善',
    content: '中共山东盛博莱电力工程有限公司支部委员会成立，公司组织管理、人才培养和项目交付体系进一步完善。',
    image: ''
  },
  {
    id: 'fallback-3',
    year: '2026',
    title: '综合服务能力突破',
    content: '围绕调试、维护、检修、电力试验、运行和油化实验室等专业方向，持续打造电力行业一站式综合服务平台。',
    image: ''
  }
]

export default {
  name: 'AboutHistoryV2',
  data() {
    return {
      historyList: fallbackHistory,
      defaultHistoryImage: defaultImage
    }
  },
  created() {
    getHistoryList().then(list => {
      if (!list || !list.length) {
        return
      }
      this.historyList = list.map(item => ({
        id: item.historyId,
        year: item.historyYear,
        title: item.historyTitle,
        content: item.historyContent,
        image: resolveFileUrl(item.imageUrl)
      }))
    }).catch(() => {})
  },
  computed: {
    displayHistoryList() {
      return this.historyList
    }
  }
}
</script>

<style lang="scss" scoped>
.history-head {
  margin-bottom: 42px;

  span {
    color: #2563eb;
    font-size: 13px;
    font-weight: 800;
    letter-spacing: 4px;
  }

  h2 {
    margin: 10px 0 12px;
    font-size: 34px;
    color: #0f172a;
  }

  p {
    font-size: 16px;
    line-height: 1.8;
    color: #64748b;
  }
}

.history-timeline {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 34px;

  &::before {
    content: '';
    position: absolute;
    left: 50%;
    top: 22px;
    bottom: 22px;
    width: 2px;
    background: linear-gradient(to bottom, #2563eb, #dbeafe);
    transform: translateX(-50%);
  }
}

.history-item {
  position: relative;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 132px minmax(0, 1fr);
  gap: 32px;
  align-items: center;
  z-index: 1;
}

.history-left {
  display: flex;
  justify-content: flex-end;
}

.history-image {
  width: 100%;
  max-width: 420px;
  height: 230px;
  overflow: hidden;
  background: #f1f5f9;
  border: 1px solid #dbe7f5;
  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.06);

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
}

.history-axis {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  &::before {
    content: '';
    position: absolute;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: #fff;
    border: 5px solid #2563eb;
    box-shadow: 0 0 0 8px rgba(37, 99, 235, 0.12);
    z-index: 1;
  }
}

.history-year {
  position: relative;
  z-index: 2;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 92px;
  height: 42px;
  padding: 0 16px;
  background: #fff;
  border: 1px solid #dbe7f5;
  color: #1d4ed8;
  font-size: 20px;
  font-weight: 800;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.08);
}

.history-card {
  display: grid;
  grid-template-columns: 70px minmax(0, 1fr);
  gap: 24px;
  align-items: start;
  min-height: 230px;
  padding: 34px;
  background: #fff;
  border: 1px solid #dbe7f5;
  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.06);
}

.history-index {
  font-size: 28px;
  font-weight: 800;
  color: rgba(37, 99, 235, 0.25);
}

.history-content {
  h3 {
    margin: 0 0 12px;
    font-size: 22px;
    color: #0f172a;
  }

  p {
    margin: 0;
    font-size: 16px;
    line-height: 1.9;
    color: #475569;
  }
}

@media (max-width: 960px) {
  .history-timeline {
    &::before {
      left: 24px;
    }
  }

  .history-item {
    grid-template-columns: 48px minmax(0, 1fr);
    gap: 18px;
    align-items: start;
  }

  .history-left {
    grid-column: 2;
    justify-content: flex-start;
    order: 2;
  }

  .history-axis {
    grid-column: 1;
    grid-row: 1 / span 2;
    align-self: start;
    margin-top: 12px;
  }

  .history-year {
    min-width: 70px;
    height: 34px;
    padding: 0 10px;
    font-size: 16px;
    transform: translateX(24px);
  }

  .history-card {
    grid-column: 2;
    grid-template-columns: 1fr;
    min-height: auto;
    padding: 28px;
    order: 1;
  }

  .history-image {
    width: 100%;
    height: 210px;
  }
}
</style>
